import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForYouSection() {
  const forYou = ['Eres mamá soltera latina 30+ en USA con ingresos $2k-4k/mes.', 'Revisas el banco a medianoche con ansiedad por las deudas.', 'Necesitas algo en español, simple y listo en 15 minutos.', 'Quieres ahorrar $100/mes sin sacrificar las remesas.', 'Usas Excel en el celular y compras en Aldi/Walmart.', 'Priorizas a tus hijos pero sueñas con un fondo de emergencia.'];
  const notForYou = ['Tienes un asesor financiero pagado.', 'Tus ingresos son mayores a $6k/mes y muy estables.', 'Prefieres apps complejas tipo YNAB.', 'No usas Excel ni Google Sheets en absoluto.', 'Buscas hacerte rica rápido, no un control realista.'];
  return <section className="py-20 px-4 bg-white" data-id="element-109">
      <div className="max-w-5xl mx-auto" data-id="element-110">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-111">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 rounded-3xl border border-success/20" data-id="element-112">
            <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-113">
              <span className="bg-success/20 text-success p-2 rounded-full" data-id="element-114">
                <CheckCircleIcon className="w-6 h-6" data-id="element-115" />
              </span>
              Esto ES para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-116">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-117">
                  <CheckCircleIcon className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-118" />
                  <span className="text-charcoal/80" data-id="element-119">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-8 rounded-3xl border border-gray-200" data-id="element-120">
            <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-121">
              <span className="bg-danger/10 text-danger p-2 rounded-full" data-id="element-122">
                <XCircleIcon className="w-6 h-6" data-id="element-123" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-124">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-125">
                  <XCircleIcon className="w-5 h-5 text-danger/60 flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span className="text-charcoal/60" data-id="element-127">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}